import { z } from 'zod';
export const SIZES = Object.freeze({
    SM: { min: 2, max: 24 },
    MD: { min: 3, max: 48 },
    LG: { min: 3, max: 63 },
});
export const SizedStringVO = ({ min, max }) => z.string().min(min).max(max);
//# sourceMappingURL=sized-string.js.map